import { useEffect, useState } from "react"

import emitter from "../emitter"
import PlatformSaveBar, { PlatformSaveBarProps } from "./PlatformSaveBar"

const UnsavedChangedBar = () => {
  const [config, setConfig] = useState<PlatformSaveBarProps>({
    open: false,
    onDiscard: () => {},
    onSave: () => {},
  })
  useEffect(() => {
    emitter.on("platform:saveBar:change", (props) => {
      setConfig(props)
    })
    return () => {
      emitter.off("platform:saveBar:change")
    }
  }, [])
  return <PlatformSaveBar {...config} />
}
export default UnsavedChangedBar
